module.exports = __webpack_public_path__ + "9060a5250da62e78fcc30a2a97e65122.pdf";